module.exports = __webpack_public_path__ + "img/SI.fce9817c.svg";